import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function GuaranteeAccordion() {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const measure = () => setHeight(contentRef.current?.scrollHeight ?? 0);
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);
  return <div style={{
    borderTop: '1px solid rgba(20,17,15,.12)',
    borderBottom: '1px solid rgba(20,17,15,.12)'
  }} data-id="element-15" data-mp="25ime7z1506z7">
      <button type="button" onClick={() => setOpen(prev => !prev)} aria-expanded={open} className="flex w-full items-center gap-3 py-6 text-left" data-id="element-16" data-mp="20kb5xsqhq4j3">
        <span className="text-[17px] font-extrabold text-ink" data-id="element-17" data-mp="1ri1zbdycevaz">THE FRIDGE TEST</span>
        <span className="text-[13px] text-ink/55" data-id="element-18" data-mp="1mlbigoeprvoi">30-day guarantee</span>
        <ChevronDownIcon aria-hidden="true" className="ml-auto h-5 w-5 flex-none text-ink/60 transition-transform duration-300 ease-out" style={{
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
      }} data-id="element-19" data-mp="1lbpjqndzzy4f" />
      </button>

      <div className="overflow-hidden transition-[max-height] duration-300 ease-out" style={{
      maxHeight: open ? `${height}px` : '0px'
    }} data-id="element-20" data-mp="1ccm11kiqtkqg">
        <div ref={contentRef} className="space-y-4 pb-5 text-[15px] leading-[1.65] text-ink/80" data-id="element-21" data-mp="24z6qgffnrmrd">
          <p data-id="element-22" data-mp="291bm1jpo2tgn">
            Print one routine tonight. Stick it on the fridge. Give it seven mornings. If morning
            number seven isn't calmer than morning number one, email us any time in the next 30 days
            and we'll refund every cent — and you keep all twelve bonuses.
          </p>
          <p data-id="element-23" data-mp="jl2dxpj0zmj6">
            We're not asking you to decide today. We're asking you to decide on the inside, after
            you've actually seen it work — the same way you don't buy a house without walking
            through it first.
          </p>
        </div>
      </div>
    </div>;
}